import { jsx as _jsx } from "react/jsx-runtime";
import { Box, Typography, useTheme } from '@mui/material';
const NoDataMessage = ({ text, sx = {} }) => {
    const theme = useTheme();
    return (_jsx(Box, { sx: {
            textAlign: 'center',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
            height: '100%',
            color: theme.palette.text.secondary,
            ...sx
        }, children: _jsx(Typography, { variant: 'caption', color: 'text.secondary', children: text }) }));
};
export default NoDataMessage;
